import React from 'react';
import StatusBadge from './StatusBadge';

/**
 * RunnerStatus Component
 * 
 * A wrapper around StatusBadge specifically for runner/execution statuses.
 * Automatically shows the animated dot for 'running' status.
 * 
 * @param {string} status - Runner status (running, stopped, starting, completed, etc.)
 * @param {string} className - Additional CSS classes
 */
const RunnerStatus = ({ status = 'stopped', className = '' }) => {
  const normalizedStatus = status?.toLowerCase?.() || 'stopped';
  const isRunning = normalizedStatus === 'running';

  return (
    <StatusBadge 
      status={normalizedStatus}
      showDot={isRunning}
      size="sm"
      className={className}
    />
  );
};

export default RunnerStatus;
